<!-- 就诊人信息 -->
<template>
  <div class="patientInformation">
    <div class="patientInfo">
      <div class="infoHeader">
        <span class="patientName">{{ patient.patientName }}</span>
        <span class="defaultTag" v-if="isDefault">默认</span>
      </div>
      <div class="patientCard">电子就诊卡: {{ patient.cardNo }}</div>
    </div>
    <div class="QRCode">
      <vue-qr v-if="patient.cardNo" :text="patient.cardNo"></vue-qr>
    </div>
    <div class="details">
      <div class="detailItem">
        <span class="label">性别</span>
        <span class="value">{{ patient.sex }}</span>
      </div>
      <div class="detailItem">
        <span class="label">出生日期</span>
        <span class="value">{{ patient.birthday }}</span>
      </div>
      <div class="detailItem">
        <span class="label">身份证</span>
        <span class="value">{{ patient.idCardNo }}</span>
      </div>
      <div class="detailItem">
        <span class="label">手机号</span>
        <span class="value">{{ patient.tel }}</span>
      </div>
      <div class="detailItem">
        <span class="label">地址</span>
        <span class="value">{{ patient.address }}</span>
      </div>
    </div>
    <div class="actions">
      <div class="defaultToggle">
        <label>设为默认就诊人</label>
        <van-switch v-model="isDefault" active-color="#01CC88" inactive-color="#dcdee0" @change="changeDefault" />
      </div>
    </div>
    <div class="deleteButton">
      <van-button style="border-radius: 8px; font-size: 5.9vw" size="large" @click="unbindWeChatUserInformation">删除就诊人</van-button>
    </div>
    <van-loading size="12vw" text-size="5vw" vertical v-if="deleteLoading" class="deleteLoading">删除中</van-loading>
  </div>
</template>

<script>
import VueQr from 'vue-qr';
import {patientInformationInquiry} from '@/api/datasyncDataviewsimulator/yinyitong/index';
import {updataisDefault} from '@/api/engineHis/wechatrofficial';
import {unbindWeChatUserInformation} from '@/api/engineHis/wechatrofficial';

export default {
  data() {
    return {
      checked: true,
      patient: {
        // name: '欧阳清风',
        // healthCard: '8001126876',
        // qrCode: '@/assets/qr_code.png',
        // gender: '男',
        // birthDate: '1986-07-17',
        // idNumber: '45088*********078',
        // phone: '15892959781',
        // address: '珠海市',
        // isDefault: true
      },
      isDefault: null,
      deleteLoading: false
    };
  },
  components: {VueQr},
  mounted() {
    this.patientInformationInquiry();
  },
  methods: {
    //
    async changeDefault() {
      const openid = this.$store.getters.openid;
      if (!openid) {
        this.$toast.fail('登录信息已失效，请重新登录');
        return;
      }

      try {
        let data = {
          openid,
          medicalCard: this.$route.params.InPatientNo,
          isDefault: this.isDefault
        };
        let res = await updataisDefault(data);
      } catch (err) {
        console.log('err', err);
      }
    },
    onBack() {
      // 返回按钮处理逻辑
    },
    // 删除就诊人处理逻辑
    async unbindWeChatUserInformation() {
      console.log(' this.$store.state.userInfo :>> ',  this.$store.state.userInfo);
      if (!this.patient) {
        return;
      }
      const openid = this.$store.getters.openid;
      if (!openid) {
        this.$toast.fail('登录信息已失效，请重新登录');
        return;
      }

      this.$dialog
        .confirm({
          title: '操作提示',
          message: '您确定要将电子就诊卡从当前微信上删除吗'
        })
        .then(async () => {
          this.deleteLoading = true;
          try {
            let data = {
              openid,
              idCard: this.patient.idCardNo,
              medicalCard: this.patient.cardNo,
              phone: this.patient.tel
            };
            let res = await unbindWeChatUserInformation(data);
            this.$toast.success('删除成功');
            this.deleteLoading = false;
            await this.$router.replace({name: 'myMedicalCard'});

            console.log('11', res);
          } catch (err) {
            console.log('>>>', err);
            this.deleteLoading = false;
            this.$toast.fail('删除失败');
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    async patientInformationInquiry() {
      this.isDefault = this.$route.params.isDefault;
      try {
        const res = await patientInformationInquiry({
          InPatientNo: this.$route.params.InPatientNo,
          cardType: '01'
        });
        if (!!res && !!res.data) {
          this.patient = res.data.patientInformation;
        }
      } catch (err) {
        console.log('err', err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.patientInformation {
  width: 100vw;
  height: 100vh;
  background: #f9f9f9;
  .patientInfo {
    padding: 1.2vh 5.3vw;
    background: #fff;

    .infoHeader {
      display: flex;
      align-items: center;
      background: #fff;
      .patientName {
        font-size: 6.4vw;
        font-weight: bold;
      }

      .defaultTag {
        margin-left: 2.7vw;
        border: 1px solid #989898;
        color: #000;
        padding: 0.3vh 3.5vw;
        border-radius: 1.3vw;
        background: #fff;
      }
    }

    .patientCard {
      margin-top: 1vh;
      font-size: 4.8vw;
      color: #666;
    }
  }

  .QRCode {
    margin: 0 auto;
    width: 64vw;
    height: 64vw;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .details {
    padding: 2.7vw;
    background: #fff;

    .detailItem {
      display: flex;
      justify-content: space-between;
      padding: 0.6vh 0;

      .label {
        font-size: 4.3vw;
        color: #666;
      }

      .value {
        font-size: 4.3vw;
        font-weight: bold;
      }
    }
  }

  .actions {
    padding: 2.7vw;
    background: #fff;

    .defaultToggle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2.5vh 0;
      border-top: 1px solid #ccc;

      label {
        font-size: 4.3vw;
      }
    }
  }

  .deleteButton {
    width: 100%;
    padding: 2.7vw;
    box-sizing: border-box;
    margin-top: 2.7vh;
  }
}
.deleteLoading,
.van-loading--vertical {
  width: 35vw;
  margin: -47vh auto 0;
  background: #4c4c4c;
  border-radius: 3.2vw;
  padding: 3vh 0;
  box-sizing: border-box;
  .van-loading__text {
    color: #fff;
  }
}
</style>
